import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  leftTitle: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: 26,
    lineHeight: '30px',
    marginBottom: '5%',
    marginTop: '5%',
    textAlign: 'start',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  description: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  forgotPassword: {
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 600,
  },
  label: {
    marginBottom: 5,
  },
}));
